import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { isPhoneLineSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const mapFilterData = (data: IPhoneLineSearchForm): IPhoneLineSearchPost | {} => {
  const newData: IPhoneLineSearchForm = {...data};
  if (isPhoneLineSearchFormEmpty(data) || data == undefined) { return {} };
  
  newData.unitType = '';
  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getPhoneLineDownloadCsv = ( {data} : {data: IPhoneLineSearchForm}): Promise<string> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  return axiosDefaultApi.post(`api/Search/ExportToCSV/PhoneLines?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData, header);
};

type QueryFnType = typeof getPhoneLineDownloadCsv;

type UseGetPhoneLineDownloadCsvOptions = {
  data: IPhoneLineSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetPhoneLineDownloadCsv = ({ config }: UseGetPhoneLineDownloadCsvOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου CSV των τηλεφωνικών γραμμών.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading phone line csv:', error);
    },
    onSuccess: () => {
      console.log('Phone Line report csv downloaded successfully.');
    },
    ...config,
    mutationFn: getPhoneLineDownloadCsv,
  })
}